import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PretendardText from "../pretendardText";

const DetailFormText = (props) => {
  return <DetailFormTextWrapper {...props} />;
};

export default DetailFormText;

const DetailFormTextWrapper = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 400;
  line-height: 21.25px;
  color: #636C73;
  max-width: 744px;
  white-space: pre-wrap;
`;
